module.exports = __webpack_public_path__ + "img/icon-save-white.6aadfa63.svg";